export const Error404 = () => {
    return (
        <div>
            <img alt="loading"
                 src="https://s2.loli.net/2022/02/02/Wnfsz6hariuxeIc.png"
                 style={{position: "absolute",
                     margin: "auto",
                     left: "0",
                     right: "0",
                     top: "0",
                     bottom: "0"}} />
        </div>
    )
}